"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const framer_motion_1 = require("framer-motion");
const lodash_1 = require("lodash");
const pattern_library_hooks_use_breakpoints_1 = require("@saatva-bits/pattern-library.hooks.use-breakpoints");
const pattern_library_components_icon_1 = require("@saatva-bits/pattern-library.components.icon");
const simple_slider_module_scss_1 = __importDefault(require("./simple-slider.module.scss"));
const modulo = (number, mod) => ((number % mod) + mod) % mod;
const wrappedSlice = (arr, start, end) => {
    start = modulo(start, arr.length);
    end = modulo(end, arr.length);
    if (end < start) {
        return [...arr.slice(start), ...arr.slice(0, end)];
    }
    return arr.slice(start, end);
};
const cloneChildrenArray = (childrenArray, isShown = false) => childrenArray.map(child => react_1.default.cloneElement(child, isShown ? { className: (0, classnames_1.default)(child.props.className, 'active') } : { 'aria-hidden': true }));
const PlaceHolder = () => (0, jsx_runtime_1.jsx)("div", { className: "u-hiddenVisually", "aria-hidden": "true" });
const breakpointArrayPosition = {
    mobile: 0,
    tablet: 1,
    desktop: 2
};
const SimpleSlider = ({ children, childClass, onChange, sliderClassName, className, sliderLabel, dotLines, index, setIndex, leftButtonClassName, rightButtonClassName, leftIcon, rightIcon, dotClassName, initialIndex = 0, transitionDuration = 200, shownSize = [1, 2, 3], showButtons = true, onChangeOffset = shownSize, pageDots = false, peekable = false, infinite = false, isCart = false, childTag = 'li', leftIconClassName = 'chevron-icon-left', rightIconClassName = 'chevron-icon-right', dotsClassName = 'u-marginTop--lg', overflow = 'hidden', pageDotsAndNumbers = false, swipeConfidenceThreshold = 10, useUncontrolledLeftMostShownIndex = true }) => {
    const [activeIndex, setActiveIndex] = (0, react_1.useState)(initialIndex);
    const [uncontrolledLeftMostShownIndex, setPage] = (0, react_1.useState)(initialIndex);
    const childArray = (0, react_1.useMemo)(() => react_1.default.Children.toArray(children), [children]);
    const { isMobile, isTablet, isDesktop } = (0, pattern_library_hooks_use_breakpoints_1.useBreakpoints)('mobile');
    const [resizeId, setResizeId] = (0, react_1.useState)(0);
    const componentId = (0, react_1.useMemo)(() => (0, lodash_1.uniqueId)(), []);
    const isTabletOrDesktop = isTablet ? 'tablet' : 'desktop';
    const breakpointSize = isMobile ? 'mobile' : isTabletOrDesktop;
    (0, react_1.useEffect)(() => {
        /**
         * there is a bug where when the viewport changes breakpoint sizes,
         * then the main area is dragged, the scale properties are not calculated correctly.
         * re-keying the elements forces the scale sizes to be updated correctly.
         */
        setResizeId(resizeId + 1);
    }, [breakpointSize, peekable]);
    (0, react_1.useEffect)(() => {
        /**
         * Parent can control the active index from the silder,
         * its different from initialIndex, this index might change through interactions
         * in the parent (maybe you switched sections or the like and the slider shows specific info)
         */
        if (typeof index !== 'undefined' && index !== activeIndex) {
            goToIndex(index);
        }
    }, [index]);
    const windowSizeIndex = breakpointArrayPosition[breakpointSize];
    const onChangeOffsetAmount = typeof onChangeOffset === 'number' ? onChangeOffset : onChangeOffset[windowSizeIndex];
    const itemsShowNum = typeof shownSize === 'number' ? shownSize : shownSize[windowSizeIndex];
    const paginateCount = Math.ceil(react_1.default.Children.count(childArray) / onChangeOffsetAmount);
    const isRecommendedProducts = showButtons && isCart;
    const isPageDotsAndNumbers = showButtons && pageDotsAndNumbers && !isDesktop;
    const presentedLength = childArray.length;
    const Component = framer_motion_1.motion[childTag];
    const longChildArray = (0, react_1.useMemo)(() => {
        const additionalChildArray = !infinite
            ? Array(presentedLength).fill((0, jsx_runtime_1.jsx)(PlaceHolder, {}))
            : childArray;
        const wrappedChildArray = [...childArray, ...additionalChildArray, ...additionalChildArray];
        let slideNumber = 0;
        return wrappedChildArray.map((ele, i) => {
            if (slideNumber === presentedLength)
                slideNumber = 0;
            ++slideNumber;
            return ((0, jsx_runtime_1.jsx)(Component, { role: "group", tabIndex: "-1", "aria-label": `slide ${slideNumber}`, "aria-roledescription": "slide", className: (0, classnames_1.default)(simple_slider_module_scss_1.default.item, childClass), layoutId: `${componentId}-${i}-${resizeId}`, layout: true, transition: { duration: (transitionDuration / 1000) * itemsShowNum }, children: ele }, `${componentId}-${i}-${resizeId}`));
        });
    }, [childArray, infinite, presentedLength, componentId, transitionDuration, itemsShowNum]);
    // if we are in desktop and we don't want to use the useUncontrolledLeftMostShownIndex, always set the leftMostShownIndex to zero
    // this behavior should be applied for slider in desktop that are shown on a single group, not like in mobile where assets are split in a few smaller groups
    const leftMostShownIndex = (!useUncontrolledLeftMostShownIndex && isDesktop) ? initialIndex : uncontrolledLeftMostShownIndex;
    // || denotes rendered content
    // farLeft || left || right || farRight
    const farLeft = leftMostShownIndex - presentedLength;
    const left = leftMostShownIndex;
    const right = left + itemsShowNum;
    const farRight = right + presentedLength;
    const disabledIcon = { strokeWidth: 2, stroke: '#cfcfcf' };
    const enabledIcon = { strokeWidth: 2, height: 25, width: 15, stroke: '#000' };
    const previousElements = cloneChildrenArray(wrappedSlice(longChildArray, farLeft, left));
    const shownElements = cloneChildrenArray(wrappedSlice(longChildArray, left, right), true);
    const afterElements = cloneChildrenArray(wrappedSlice(longChildArray, right, farRight));
    const elements = [...previousElements, ...shownElements, ...afterElements];
    const disabledLeftButton = !infinite && activeIndex === 0;
    const disabledRightButton = !infinite && activeIndex === (paginateCount - 1);
    const updateIndex = (newIndex) => {
        if (newIndex < 0)
            newIndex = paginateCount - 1;
        else if (newIndex >= paginateCount)
            newIndex = 0;
        setActiveIndex(newIndex);
        setIndex && setIndex(newIndex);
    };
    const goToIndex = (newIndex) => {
        setPage(onChangeOffsetAmount * newIndex);
        updateIndex(newIndex);
    };
    const paginate = (newDirection) => {
        /* if not an infinite loop, we need to prevent navigation beyond the main set of slides */
        const canNotMove = ((disabledLeftButton && newDirection === -1) || // is first moving backward
            (disabledRightButton && newDirection === 1) // is last moving forward
        );
        if (!canNotMove) {
            if (onChange)
                onChange(leftMostShownIndex + newDirection * onChangeOffsetAmount);
            setPage(leftMostShownIndex + newDirection * onChangeOffsetAmount);
            updateIndex(activeIndex + newDirection);
        }
    };
    const dotPaginate = (newIndex) => {
        if (onChange)
            onChange();
        goToIndex(newIndex);
    };
    const totalItemsRendered = itemsShowNum + presentedLength * 2;
    const fullSizeRatio = (totalItemsRendered / itemsShowNum) * 100;
    const widthOffset = isMobile && isCart || isTablet && isCart ? 50 : 0;
    const calculatedWidth = peekable ? 'auto' : `${fullSizeRatio - widthOffset}%`;
    const dataSelectorPrefix = sliderLabel && `${sliderLabel.replace(/\s+/g, '-')}-slider`.toLowerCase();
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('simple-slider', sliderClassName), "aria-roledescription": "carousel", "aria-label": sliderLabel, role: "region", "data-selector": dataSelectorPrefix, children: [(0, jsx_runtime_1.jsxs)("div", { children: [showButtons && !isCart &&
                        (0, jsx_runtime_1.jsx)("button", { className: (0, classnames_1.default)(simple_slider_module_scss_1.default.leftButton, leftButtonClassName), type: "button", "aria-label": "go to previous slide", onClick: () => paginate(-1), "data-selector": `${dataSelectorPrefix}-previous-button`, disabled: disabledLeftButton, children: leftIcon || ((0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { description: "Chevron Left", alt: "Chevron Left", name: "chevron-left", titleId: "chevronLeftIcon", className: leftIconClassName, style: disabledLeftButton ? disabledIcon : enabledIcon })) }), (0, jsx_runtime_1.jsx)("div", { role: "main", "data-selector": `${dataSelectorPrefix}-container`, className: (0, classnames_1.default)(simple_slider_module_scss_1.default.container, className, {
                            [simple_slider_module_scss_1.default[`containerOverflow--${overflow}`]]: overflow
                        }), children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.ul, { drag: 'x', dragElastic: 0.1, dragConstraints: { left: 0, right: 0 }, onDragEnd: (_, { offset }) => {
                                if (offset.x < -swipeConfidenceThreshold)
                                    paginate(1);
                                else if (offset.x > swipeConfidenceThreshold)
                                    paginate(-1);
                            }, dragTransition: { bounceDamping: 999999 }, "aria-live": "off", className: simple_slider_module_scss_1.default.items, style: { width: calculatedWidth }, children: elements }) }), showButtons && !isCart &&
                        (0, jsx_runtime_1.jsx)("button", { className: (0, classnames_1.default)(simple_slider_module_scss_1.default.rightButton, rightButtonClassName), type: "button", "aria-label": "go to next slide", onClick: () => paginate(1), "data-selector": `${dataSelectorPrefix}-next-button`, disabled: disabledRightButton, children: rightIcon || ((0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { description: "Chevron Right", alt: "Chevron Right", name: "chevron-right", titleId: "chevronRightIcon", className: rightIconClassName, style: disabledRightButton ? disabledIcon : enabledIcon })) })] }), (pageDots || pageDotsAndNumbers) &&
                (0, jsx_runtime_1.jsxs)("ul", { "data-selector": `${dataSelectorPrefix}-dots`, className: (0, classnames_1.default)(simple_slider_module_scss_1.default.dots, dotsClassName), "data-testid": 'simple-slider-dots', children: [(isRecommendedProducts || isPageDotsAndNumbers) &&
                            (0, jsx_runtime_1.jsx)("li", { className: simple_slider_module_scss_1.default.rightCartButtonItem, children: (0, jsx_runtime_1.jsx)("button", { className: (0, classnames_1.default)(simple_slider_module_scss_1.default.cartLeftButton, leftButtonClassName), type: "button", "aria-label": "go to previous slide", onClick: () => paginate(-1), "data-selector": `${dataSelectorPrefix}-previous-button`, disabled: disabledLeftButton, children: leftIcon || ((0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { description: "Chevron Left", alt: "Chevron Left", name: "chevron-left", titleId: "chevronLeftIcon", className: leftIconClassName, style: (activeIndex > 0 || infinite) ? enabledIcon : disabledIcon })) }) }), [...Array(paginateCount).keys()].map(dotIndex => {
                            const pageNumber = dotIndex + 1;
                            const isCurrentPage = dotIndex === activeIndex;
                            const dotClasses = (0, classnames_1.default)(simple_slider_module_scss_1.default.dot, dotClassName, {
                                [simple_slider_module_scss_1.default['dot--active']]: isCurrentPage,
                                [simple_slider_module_scss_1.default['dot--lined']]: dotLines,
                                [simple_slider_module_scss_1.default['dot--lined--active']]: dotLines && isCurrentPage,
                                [simple_slider_module_scss_1.default['dot--hidden']]: isPageDotsAndNumbers
                            });
                            return ((0, jsx_runtime_1.jsx)("li", { className: dotClasses, children: (0, jsx_runtime_1.jsx)("button", { type: "button", "data-slide": dotIndex, "aria-current": isCurrentPage, "aria-label": `go to slide ${pageNumber}`, onClick: () => {
                                        !isCurrentPage && dotPaginate(dotIndex);
                                    } }) }, dotIndex));
                        }), isPageDotsAndNumbers &&
                            (0, jsx_runtime_1.jsx)("div", { className: simple_slider_module_scss_1.default.slidesCounter, children: `${activeIndex + 1} of ${paginateCount}` }), (isRecommendedProducts || isPageDotsAndNumbers) &&
                            (0, jsx_runtime_1.jsx)("li", { className: simple_slider_module_scss_1.default.leftCartButtonItem, children: (0, jsx_runtime_1.jsx)("button", { className: (0, classnames_1.default)(simple_slider_module_scss_1.default.cartRightButton, rightButtonClassName), type: "button", "aria-label": "go to next slide", onClick: () => paginate(1), "data-selector": `${dataSelectorPrefix}-next-button`, disabled: disabledRightButton, children: rightIcon || ((0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { description: "Chevron Right", alt: "Chevron Right", name: "chevron-right", titleId: "chevronRightIcon", className: rightIconClassName, style: (paginateCount > (activeIndex + 1) || infinite) ? enabledIcon : disabledIcon })) }) })] }), (0, jsx_runtime_1.jsx)("div", { "aria-live": "polite", "aria-atomic": "true", className: "liveregion u-hiddenVisually", children: `slide page ${activeIndex + 1} of ${paginateCount}` })] }));
};
SimpleSlider.propTypes = {
    /** Content that will be rendered as children array of the SimpleSlider component. */
    children: prop_types_1.default.node,
    /** Number the displaying slides. */
    shownSize: prop_types_1.default.oneOfType([
        prop_types_1.default.number,
        prop_types_1.default.array
    ]),
    /** Number of the offset slides. */
    onChangeOffset: prop_types_1.default.oneOfType([
        prop_types_1.default.number,
        prop_types_1.default.array
    ]),
    /** Applies a custom class to the SimpleSlider wrapper. */
    sliderClassName: prop_types_1.default.string,
    /** Applies a custom class to the SimpleSlider container. */
    className: prop_types_1.default.string,
    /** Applies a custom class to the children components. */
    childClass: prop_types_1.default.string,
    /** Declares the HTML tag for the wrapping element of each slide. */
    childTag: prop_types_1.default.string,
    /** To fire an onchange event to the parent of the SimpleSlider.
     * (Note: A parent element can access the pagination index throught this function)
    */
    onChange: prop_types_1.default.func,
    /** The width of slider is determined by its contents and centered within its container to enable peeking on both sides. */
    peekable: prop_types_1.default.bool,
    /** Applies a required custom label to the SimpleSlider. */
    sliderLabel: prop_types_1.default.string.isRequired,
    /** Show the dots pagination to the slider. */
    pageDots: prop_types_1.default.bool,
    /** Show a numeric pagination on mobile and tablet. */
    pageDotsAndNumbers: prop_types_1.default.bool,
    /** Style the dots pagination as a line. */
    dotLines: prop_types_1.default.bool,
    /** Show the button controls to the slider. */
    showButtons: prop_types_1.default.bool,
    /** Sets the active index and pagination. */
    index: prop_types_1.default.number,
    /** To set the current index to the parent of the SimpleSlider. */
    setIndex: prop_types_1.default.func,
    /** Number of the initial active slide(s). */
    initialIndex: prop_types_1.default.number,
    /** To hidde or show the overflow the slider. */
    overflow: prop_types_1.default.oneOf(['hidden', 'visible']),
    /** Applies a custom class to the left button. */
    leftButtonClassName: prop_types_1.default.string,
    /** Applies a custom class to the right button. */
    rightButtonClassName: prop_types_1.default.string,
    /** Content that will be rendered as Icon of the left button. */
    leftIcon: prop_types_1.default.node,
    /** Content that will be rendered as Icon of the right button. */
    rightIcon: prop_types_1.default.node,
    /** Applies a custom class to the left icon. */
    leftIconClassName: prop_types_1.default.string,
    /** Applies a custom class to the right icon. */
    rightIconClassName: prop_types_1.default.string,
    /** Applies a custom class to the dots wrapper. */
    dotsClassName: prop_types_1.default.string,
    /** Applies a custom class to each dot. */
    dotClassName: prop_types_1.default.string,
    /** Applies infinite scroll to the SimpleSlider,
     * KEEP IN MIND using infinite along with dotLines or pageDots
     * can cause weird animation behavior if the user clicks constantly the
     * next or previous slide buttons and then interacts with the pagination
     * immediately.
    */
    infinite: prop_types_1.default.bool,
    /** Applies a transition duration in milliseconds when slides */
    transitionDuration: prop_types_1.default.number,
    /** Set pagination buttons with recommended products styling. */
    isCart: prop_types_1.default.bool,
    /** Set the distance that need to be traveled to swipe to a different slide (on mobiles devices) */
    swipeConfidenceThreshold: prop_types_1.default.number
};
exports.default = SimpleSlider;
//# sourceMappingURL=simple-slider.js.map